.figure {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.device {
  width: min(340px, 100%);
  border-radius: 38px;
  background: var(--paper);
  border: 1px solid var(--edge);
  box-shadow: var(--shadow-phone);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Status bar */
.statusBar {
  height: 32px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 26px;
}

.statusTime {
  font-size: 12px;
  font-weight: 600;
  color: var(--ink);
}

.statusIcons {
  display: flex;
  align-items: center;
  gap: 4px;
}

.signal {
  width: 13px;
  height: 8px;
  border-radius: 2px;
  background: var(--ink);
  opacity: 0.85;
}

.battery {
  width: 19px;
  height: 9px;
  border-radius: 2px;
  border: 1px solid rgb(38 36 31 / 50%);
  position: relative;
}

.batteryFill {
  position: absolute;
  inset: 1.5px;
  right: 5px;
  border-radius: 1px;
  background: var(--ink);
}

/* The day */
.dayRow {
  padding: 6px 22px 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.day {
  font-family: var(--font-display);
  font-size: 26px;
  line-height: 1.15;
  color: var(--ink);
}

.cog {
  color: var(--ink-muted);
  padding-top: 4px;
  line-height: 1;
}

/* The last reading */
.hero {
  margin: 18px 22px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--rule);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.heroValue {
  display: flex;
  align-items: flex-end;
  gap: 7px;
}

.value {
  font-family: var(--font-display);
  font-size: 66px;
  line-height: 0.82;
  color: var(--ink);
}

.unit,
.heroTime {
  font-size: 13px;
  color: var(--ink-muted);
  padding-bottom: 6px;
}

.summary {
  margin: 14px 22px 0;
  font-family: var(--font-display);
  font-size: 15px;
  line-height: 1.5;
  color: var(--ink-body);
}

/* The day strip */
.strip {
  margin: 18px 22px 0;
  height: 62px;
  position: relative;
}

.stripBand {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 14px;
  height: 26px;
  background: var(--band);
}

.stripAxis {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: var(--outline);
}

.dot {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ink);
  margin-left: -4.5px;
}

.hours {
  margin: 5px 22px 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  font-size: 11px;
  color: var(--ink-faint);
}

.hours span:nth-child(2),
.hours span:nth-child(3),
.hours span:nth-child(4) {
  text-align: center;
}

.hours span:last-child {
  text-align: right;
}

/* The day's entries */
.rows {
  margin: 16px 22px 0;
  display: flex;
  flex-direction: column;
}

.row {
  display: grid;
  grid-template-columns: 48px 1fr;
  column-gap: 14px;
  padding: 11px 0;
  border-top: 1px solid var(--rule);
  align-items: baseline;
}

.rowTime {
  font-family: var(--font-display);
  font-size: 14px;
  color: var(--ink-muted);
}

.rowText {
  font-size: 15px;
  color: var(--ink);
}

.rowTextSerif {
  font-family: var(--font-display);
  font-size: 15px;
  line-height: 1.45;
  color: var(--ink);
}

/* Quick tiles */
.quick {
  margin-top: 14px;
  padding: 10px 18px 12px;
  border-top: 1px solid var(--rule);
  display: flex;
  gap: 7px;
}

.tile {
  flex: 1;
  height: 52px;
  border-radius: 15px;
  background: var(--paper-raised);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: var(--ink);
}

.tileLabel {
  font-size: 10.5px;
  color: var(--ink-body);
}

/* Tab bar */
.tabs {
  border-top: 1px solid var(--rule);
  background: var(--paper-band);
  display: flex;
}

.tab {
  flex: 1;
  padding: 9px 0 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  font-size: 10.5px;
  color: var(--ink-faint);
}

.tabActive {
  color: var(--ink);
}

.homeBar {
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--paper-band);
}

.homeBar span {
  width: 120px;
  height: 5px;
  border-radius: 3px;
  background: rgb(38 36 31 / 26%);
}

.caption {
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--ink-muted);
  text-align: center;
  max-width: 34ch;
}
